import React, { Component } from 'react'

export default class Error extends Component {
    render() {
        return (
            <div id="mainDiv">
                <div class="fof">
                    <h1>Error 404</h1>
                </div>
            </div>
        )
    }
}
